export default {
  mySalesNotAvailableTitle: {
    id: 'buyback_my_sales_not_available_title',
    defaultMessage: 'Trade-in is temporarily offline',
  },
  mySalesNotAvailableContent: {
    id: 'buyback_my_sales_not_available_content',
    defaultMessage:
      "We're unable to display your trade-in information at the moment. Please check back soon.",
  },
}
